// TODO: Remove
module.exports = require('./event-emitter')
